/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { StoriesUpdatePathParams, StoriesUpdateRequest, StoriesUpdateResponse } from '../types/StoriesUpdate'

/**
 * PUT /ad-generation/stories/:story
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/StoryController.php StoryController::update
 */
export async function storiesUpdate(
	story: StoriesUpdatePathParams['story'],
	data: StoriesUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<StoriesUpdateResponse>> {
	return axiosInstance.put(`/ad-generation/stories/${story}`, data, config)
}
